import Model from "@/models/Model"

export default class ASendEmailRestorePass extends Model {
    resource() {
        return "send_email_restore_pass"
    }
}